import { createFileRoute } from '@tanstack/react-router';

import { requireOwnerOrAdmin } from '~/lib/route-auth';
import { ReportsPageComponent } from '~/page-components/reports-page';

export const Route = createFileRoute('/reports')({
  beforeLoad: async () => {
    await requireOwnerOrAdmin();
  },
  component: ReportsPageComponent
});
